import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormControl} from '@angular/forms';
import { ViewobserverService } from '../service/viewobserver.service';
import { MarkersService } from '../service/markers.service';
import { PlacesInterface } from '../models/marker';
import { GoogleChartInterface } from 'ng2-google-charts/ng2-google-charts';
import { BQRequestService } from '../service/bqrequest.service';
import { MatSnackBar } from '@angular/material';
import { SimplifyAP, ISimplifyArrayPoint} from 'simplify-ts';
import { ma, sma } from 'moving-averages';
import { ChartSelectEvent } from 'ng2-google-charts/ng2-google-charts';
import { saveAs } from 'file-saver' //para descargar consultas en historicos
import { start } from 'repl';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  datatable: any;
  private sub: any;
  emptyTable = [
    ['ts', '-', '-', '-' ],
    ['10:15',  0, 0, 0],
    ['10:16',  0, 0, 0],
    ['10:17',  0, 0, 0],
    ['10:18',  0, 0, 0],
    ['10:19',  0, 0, 0],
    ['10:20',  0, 0, 0],
    ['10:21',  0, 0, 0],
    ['10:22',  0, 0, 0],
    ['10:23',  0, 0, 0],
    ['10:23',  0, 0, 0],
  ];
  devs = '';
  telem = [];
  public graphsBorderWidth: number= 1;
  showProgress: boolean = false;
  progressMode = "query";
  places: PlacesInterface[];
  isMobile: Boolean = false;
  date1 = new FormControl();
  date2 = new FormControl();
  startDate = new Date(new Date().setDate(new Date().getDate() - 1));
  endDate = new Date();
  typeSelectControl = new FormControl();
  telemSelected = new FormControl();
  PMselected = new FormControl();
  MTselected = new FormControl();
  UPSselected = new FormControl();
  candownload = false;
  calculatedkwh = '0';
  showkwh = false;
  typeSelected: string;
  maxDate = new Date(); //today
  dummy = new Date(); //buffer date
  minDate = new Date(this.dummy.setFullYear(this.dummy.getFullYear() - 1)); //one year back
  devices = ["PM - Energia", "MT - Temperatura", "UPS"]; //eliminado el I/O por ahora hasta discutir forma de mostrar datos
  PMtelem = ["V1", "V2", "V3", "V1_V2", "V2_V3", "V3_V1", "I1", "I2", "I3", "P1", "P2", "P3", "PT", "S1", "S2", "S3", "ST", "FP", "E", "freq"];
  UPStelem = ["V1i", "V1o", "V2i", "V2o", "V3i", "V3o", "I1i", "I1o", "I2i", "I2o", "I3i", "I3o", "freqi", "freqo", "pLoad"];
  MTtelem = ["Temp"];
  public SMAEpsilon = 50;

  selectedCount = 0;
  selectedCount2 = 0;

  //to download option
  zone = '';
  city = '';
  office = '';
  device = '';
  result: any;
  selectedParams = [];

  constructor(
      private observer: ViewobserverService,
      private markersService: MarkersService,
      private requestService: BQRequestService,
      private dataRoute: ActivatedRoute,
      private snackBar: MatSnackBar
      ) { }

    public superChart: GoogleChartInterface = {
      chartType: 'LineChart',
      dataTable: [
        ['ts', '-', '-', '-' ],
        ['10:15',  0, 0, 0],
        ['10:16',  0, 0, 0],
        ['10:17',  0, 0, 0],
        ['10:18',  0, 0, 0],
        ['10:19',  0, 0, 0],
        ['10:20',  0, 0, 0],
        ['10:21',  0, 0, 0],
        ['10:22',  0, 0, 0],
        ['10:23',  0, 0, 0],
        ['10:23',  0, 0, 0],
      ],
    options: 
      {
        legend: {position: 'top'},
        backgroundColor: {fill: '#1b1b1c'},
        legendTextStyle: { color: '#FFF' },
        borderWidth: 1,
        trendlines: {
          0: {
            color: 'yellow',
            lineWidth: 2,
            type: 'polynomial',
            degree: 4,
            opacity: 0.6
          }
        },
        height: 400,
        chartArea: { left: 70, right: 10, top: 30, bottom: 50},
        animation: {duration: 900, easing: 'inAndOut'},
        explorer: {
                    axis: 'horizontal',
                    maxZoomIn: 0,
                    maxZoomOut: 1,
                    keepInBounds: true,
                    actions: ['dragToZoom', 'rightClickToReset']
                  },
        hAxis: {
                title: 'Hora (hh:mm)',
                titleTextStyle:{color: '#FFF'},
                visible: 'true',
                textStyle:{color: '#FFF'},
                gridlines: {color: 'transparent'},
                textPosition: 'bottom'                
               },
        vAxis: {
                visible: 'true',
                textStyle:{color: '#FFF'},
                titleTextStyle:{color: 'white'},
                gridlines: {color: 'gray'},
                position: 'in',
                viewWindow: {min:0}
              },
        options: {
                  responsive: true, 
                },
        colors: ['#FE1B07','#FFF','#27C5F8', '#FFFF00'],
        lineWidth: 1.5,
        //pointShape: "circle",
        //pointSize: 6, 
        //pointSizeShadow: 0,
        forcelFrame: "true",
      }
  };

  @HostListener('window:resize', ['$event'])
  sizeChange($event){
    clearTimeout(this.doit);
    let superCharto = this.superChart;


    this.doit = setTimeout(function(){
      //update current
      let ccComponent = superCharto.component;
      let ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();
     
    }, 200);
    
  }

  public doit
  trigger(){
    window.dispatchEvent(new Event('resize'));    
  }

  ngOnInit() {
    this.date1.disable();
    this.date2.disable();
    //retrieves the markers to place in map
    this.markersService.getMarkers().subscribe(marker =>{
      this.places = marker;
    })
    
    //observer to get view size 
    this.observer.getMode().subscribe(result =>{
      this.isMobile = result.matches;
    })

    const key = this.dataRoute.snapshot.params['type'];
    if (key == 'PM')
    {
      document.getElementById('ab').className = 'nav-options mat-button selected';
      this.devs = 'PM - Energia';
      this.changeTypeSel(this.devs);
      this.typeSelectControl.setValue(this.devs);
      this.typeSelectControl.updateValueAndValidity();
      
      this.PMselected.setValue(this.dataRoute.snapshot.params['site']);
      var values = [];
      if (this.dataRoute.snapshot.params['V1'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['V1']);
      }
      if (this.dataRoute.snapshot.params['V2'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['V2']);
      }
      if (this.dataRoute.snapshot.params['V3'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['V3']);
      }
      if (this.dataRoute.snapshot.params['V1_V2'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['V1_V2']);
      }
      if (this.dataRoute.snapshot.params['V2_V3'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['V2_V3']);
      }
      if (this.dataRoute.snapshot.params['V3_V1'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['V3_V1']);
      }
      if (this.dataRoute.snapshot.params['C1'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['C1']);
      }
      if (this.dataRoute.snapshot.params['C2'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['C2']);
      }
      if (this.dataRoute.snapshot.params['C3'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['C3']);
      }
      if (this.dataRoute.snapshot.params['P1'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['P1']);
      }
      if (this.dataRoute.snapshot.params['P2'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['P2']);
      }
      if (this.dataRoute.snapshot.params['P3'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['P3']);
      }
      if (this.dataRoute.snapshot.params['PT'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['PT']);
      }
      if (this.dataRoute.snapshot.params['S1'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['S1']);
      }
      if (this.dataRoute.snapshot.params['S2'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['S2']);
      }
      if (this.dataRoute.snapshot.params['S3'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['S3']);
      }
      if (this.dataRoute.snapshot.params['ST'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['ST']);
      }
      if (this.dataRoute.snapshot.params['FP'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['FP']);
      }
      if (this.dataRoute.snapshot.params['E'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['E']);
      }
      if (this.dataRoute.snapshot.params['freq'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['freq']);
      }

      console.log(values);
      this.delay(100).then(any=>{
        this.telemSelected.setValue(values);
        this.telemSelected.updateValueAndValidity();
      })
      this.telem = values;
    }
    
    if (key == 'MT')
    {
      document.getElementById('ab').className = 'nav-options mat-button selected';
      this.devs = 'MT - Temperatura';
      this.changeTypeSel(this.devs);
      this.typeSelectControl.setValue(this.devs);
      this.typeSelectControl.updateValueAndValidity();
      
      this.MTselected.setValue(this.dataRoute.snapshot.params['site']);
      var values = [];
      if (this.dataRoute.snapshot.params['T'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['T']);
      }
      
      this.delay(100).then(any=>{
        this.telemSelected.setValue(values);
        this.telemSelected.updateValueAndValidity();
      })
      this.telem = values;
    }

    if (key == 'UPS')
    {
      document.getElementById('ab').className = 'nav-options mat-button selected';
      this.devs = this.dataRoute.snapshot.params['type'];
      this.changeTypeSel(this.devs);
      this.typeSelectControl.setValue(this.devs);
      this.typeSelectControl.updateValueAndValidity();
      
      this.UPSselected.setValue(this.dataRoute.snapshot.params['site']);
      var values = [];
      if (this.dataRoute.snapshot.params['pLoad'] !== "null")
      {
        values.push(this.dataRoute.snapshot.params['pLoad']);
      }
      
      this.delay(100).then(any=>{
        this.telemSelected.setValue(values);
        this.telemSelected.updateValueAndValidity();
      })
      this.telem = values;
    }

  }

  redrawfunction(chart){
    let ccComponent = chart.component;
    let ccwrapper = ccComponent.wrapper;

    //redraw
    ccComponent.draw();
  }

  changeTypeSel(type: string){
    this.telemSelected.setValue('');
    this.typeSelectControl.updateValueAndValidity();
    this.delay(50).then(any=>{
      if (this.typeSelectControl.value == 'PM - Energia')
        {this.typeSelected = 'PM';}
      else if (this.typeSelectControl.value == 'MT - Temperatura')
        {this.typeSelected = 'MT';}
      else if (this.typeSelectControl.value == 'UPS')
      {this.typeSelected = 'UPS';}
    })
    
  }

  update_chart(chart, telem, ts?){
    var data = chart.dataTable;
    var header = chart.dataTable[0]; //copy of header
    //var year = new Date().getFullYear();
    //var month = new Date().getMonth();
    //var day = new Date().getDate();
    //var hour = new Date().getHours();
    //var mins = new Date().getMinutes();
    //var secs = new Date().getSeconds();
    //var newts = new Date(year, month, day, hour, mins, secs);
    var payload = [];
    if(ts != null){var d = new Date(ts); payload.push(d);}else{ null;}
    
    data = data.slice(0); // make copy
    data.splice(0, 1);
    ///agregar
    var i
    for(i=0; i<telem.length; i++){
      payload.push(parseFloat(telem[i]));
    }
    data.splice(data.length+1, 1, payload);
    //data.splice(0, 1);
    data.splice(0, 1, header); 
    chart.dataTable = data;
  }

  get_device_telemetry(id: string){
    this.showkwh = false;
    this.candownload = false;
    if (this.date1.value == null || this.date2.value == null)
      { 
        this.snackBar.open('Debe seleccionar fecha de inicio y fin!', 'x', {duration: 3500, verticalPosition: 'top'}); 
      }
      else
      {
        if (this.date1.value > this.date2.value)
        {
          this.snackBar.open('Fecha de inicio no puede ser mayor a fecha de fin', 'x', {duration: 3500, verticalPosition: 'top'});
          this.date1.setValue(null);
          this.date2.setValue(null);
        }
        else
        {
          if (this.telemSelected.value == '')
            {
              this.snackBar.open('Debe seleccionar al menos un parametro', 'x', {duration: 3500, verticalPosition: 'top'});
              this.telemSelected.setErrors({'notUnique': true});
            }
            else if(this.telemSelected.value.length > 1 && this.telemSelected.value[0] == 'E')
            {
              this.snackBar.open('Para ver energia solo debe estar seleccionado ese parametro', 'x', {duration: 3500, verticalPosition: 'top'});
              this.telemSelected.setErrors({'notUnique': true});
            }
            else if(this.telemSelected.value.length > 1 && this.telemSelected.value[this.telemSelected.value.length-1] == 'E')
            {
              this.snackBar.open('Para ver energia solo debe estar seleccionado ese parametro', 'x', {duration: 3500, verticalPosition: 'top'});
              this.telemSelected.setErrors({'notUnique': true});
            }
            else if(this.PMselected.value == null && this.typeSelected == 'PM')
            {
              this.snackBar.open('Debe seleccionar un PM', 'x', {duration: 3500, verticalPosition: 'top'});
              this.PMselected.setErrors({'notUnique': true});
            }
            else if(this.MTselected.value == null && this.typeSelected == 'MT')
            {
              this.snackBar.open('Debe seleccionar un MT', 'x', {duration: 3500, verticalPosition: 'top'});
              this.MTselected.setErrors({'notUnique': true});
            }
            else if(this.UPSselected.value == null && this.typeSelected == 'UPS')
            {
              this.snackBar.open('Debe seleccionar un UPS', 'x', {duration: 3500, verticalPosition: 'top'});
              this.UPSselected.setErrors({'notUnique': true});
            }
            else
            {
            this.telemSelected.setErrors(null);
            this.progressMode = "query";
            this.showProgress = true;
            var dummy = id.split("-");
            var device = dummy[3];
            var zone =  dummy[0];
            var city = dummy[1];
            var office = dummy[2];

            this.superChart.options.colors = ["#FE1B07", "#FFF", "#27C5F8", "#FFFF00"]; // esto vuelve a hacer visibles las lineas ocultas

            var startDate = this.date1.value.getFullYear() + '-' + ( '0' + (this.date1.value.getMonth()+1)).slice(-2) + '-' + ('0' + this.date1.value.getDate()).slice(-2) + ' 00:00:00';
            
            var endDate = this.date2.value.getFullYear() + '-' + ( '0' + (this.date2.value.getMonth()+1)).slice(-2) + '-' + ('0' + this.date2.value.getDate()).slice(-2) + ' 23:59:00';
            

            //aqui se procesa que parametros se piden
            var selectedParams = '';
            var headerParams = [];
            var d
            var j
            if (this.telemSelected.value[0] == 'I1')
            {
              selectedParams = selectedParams + 'C1';
            }
            else if (this.telemSelected.value[0] == 'I2')
            {
              selectedParams = selectedParams + 'C2';
            }
            else if (this.telemSelected.value[0] == 'I3')
            {
              selectedParams = selectedParams + 'C3';
            }
            else if (this.telemSelected.value[0] == 'I1i')
            {
              selectedParams = selectedParams + 'C1i';
            }
            else if (this.telemSelected.value[0] == 'I2i')
            {
              selectedParams = selectedParams + 'C2i';
            }
            else if (this.telemSelected.value[0] == 'I3i')
            {
              selectedParams = selectedParams + 'C3i';
            }
            else if (this.telemSelected.value[0] == 'I1o')
            {
              selectedParams = selectedParams + 'C1o';
            }
            else if (this.telemSelected.value[0] == 'I2o')
            {
              selectedParams = selectedParams + 'C2o';
            }
            else if (this.telemSelected.value[0] == 'I3o')
            {
              selectedParams = selectedParams + 'C3o';
            }
            else
            {
              selectedParams = selectedParams + this.telemSelected.value[0];
            }
            
            for (d= 1; d < this.telemSelected.value.length; d++ )
              {
                if (this.telemSelected.value[d] == 'I1')
                {
                  selectedParams = selectedParams + ',C1';
                }
                else if (this.telemSelected.value[d] == 'I2')
                {
                  selectedParams = selectedParams + ',C2';
                }
                else if (this.telemSelected.value[d] == 'I3')
                {
                  selectedParams = selectedParams + ',C3';
                }
                else if (this.telemSelected.value[d] == 'I1i')
                {
                  selectedParams = selectedParams + ',C1i';
                }
                else if (this.telemSelected.value[d] == 'I2i')
                {
                  selectedParams = selectedParams + ',C2i';
                }
                else if (this.telemSelected.value[d] == 'I3i')
                {
                  selectedParams = selectedParams + ',C3i';
                }
                else if (this.telemSelected.value[d] == 'I1o')
                {
                  selectedParams = selectedParams + ',C1o';
                }
                else if (this.telemSelected.value[d] == 'I2o')
                {
                  selectedParams = selectedParams + ',C2o';
                }
                else if (this.telemSelected.value[d] == 'I3o')
                {
                  selectedParams = selectedParams + ',C3o';
                }
                else
                {
                  selectedParams = selectedParams + ','+this.telemSelected.value[d];
                }
                  
              }
            //aqui se procesan los parametros pedidos para asignar a la grafica
            headerParams[0] = 'ts';
            for (d= 0; d < this.telemSelected.value.length; d++ )
            {
              headerParams[d+1] = this.telemSelected.value[d];
            }

            //se hace wipe al dataset para no tener errores en el grafico luego
            this.update_chart(this.superChart, [0, 0, 0]);

            this.superChart.dataTable = [
              ['ts', '-', '-', '-' ],
              ['10:15',  0, 0, 0],
              ['10:16',  0, 0, 0],
              ['10:17',  0, 0, 0],
              ['10:18',  0, 0, 0],
              ['10:19',  0, 0, 0],
              ['10:20',  0, 0, 0],
              ['10:21',  0, 0, 0],
              ['10:22',  0, 0, 0],
              ['10:23',  0, 0, 0],
              ['10:23',  0, 0, 0],
            ];

            this.sub = this.requestService.sendLargeRequestGraph(device, this.typeSelected, zone , city, office, selectedParams, startDate, endDate ).subscribe(result =>{
              var i;
              var ts;
              var tolerance: number = 0.1;
              if (result[0] != undefined)
              {var arrData = Object.keys(result).length; console.log('Query Size: ', arrData); console.log(result); 
              this.candownload = true; 
              this.result = result;
              this.zone = zone;
              this.city = city;
              this.office = office;
              this.device = device;}

              if (arrData < 8000)
              {tolerance = 0;}
              else if (arrData > 8000  && arrData < 10000)
              {tolerance = 0.1;}
              else if (arrData > 10000 && arrData < 15000)
              {tolerance = 0.5;}
              else if (arrData > 15000 && arrData < 20000)
              {tolerance = 0.7;}
              else if (arrData > 20000 && arrData < 30000)
              {tolerance = 0.9;}
              else if (arrData > 30000 && arrData < 40000)
              {tolerance = 2;}
              else if (arrData > 40000 && arrData < 50000)
              {tolerance = 3;}
              else if (arrData > 50000 && arrData < 60000)
              {tolerance = 4;}
              else if (arrData > 60000 && arrData < 70000)
              {tolerance = 5.3;}
              else if (arrData > 70000 && arrData < 80000)
              {tolerance = 5.5;}
              else if (arrData > 80000 && arrData < 90000)
              {tolerance = 6.3;}
              else if (arrData > 90000 && arrData < 100000)
              {tolerance = 7;}
              else if (arrData > 100000 && arrData < 120000)
              {tolerance = 8;}
              else if (arrData > 120000)
              {tolerance = 8.7;}

              console.log(this.telemSelected.value);
              //Heuristics para unidad en eje Y
              //Temp
              if (this.telemSelected.value == 'Temp')
              {
                tolerance = 0.1;
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = '°C';
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //freq
              if (this.telemSelected.value == 'freq')
              {
                tolerance = 0.1;
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'Hz';
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //FP
              else if (this.telemSelected.value == 'FP')
              {
                tolerance = 0.1;
                this.superChart.options.vAxis.viewWindow.min = null;
                this.superChart.options.vAxis.title = null;
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //E
              else if (this.telemSelected.value == 'E')
              {
                this.superChart.options.vAxis.viewWindow.min = null;
                this.superChart.options.vAxis.title = 'kWh';
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
                let dummy = parseFloat(this.result[0][0]) - parseFloat(this.result[arrData-1][0])
                this.calculatedkwh = dummy.toFixed(1);
                console.log(this.calculatedkwh);
                this.showkwh = true;
              }
              //Corrientes
              else if (this.telemSelected.value == 'I1' || this.telemSelected.value == 'I2' || this.telemSelected.value == 'I3' || this.compare(this.telemSelected.value, ['I1', 'I2']) || this.compare(this.telemSelected.value, ['I1', 'I3']) || this.compare(this.telemSelected.value, ['I2', 'I3']) || this.compare(this.telemSelected.value, ['I1', 'I2', 'I3']))
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'Amps';
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Potencia
              else if (this.telemSelected.value == 'P1' || this.telemSelected.value == 'P2' || this.telemSelected.value == 'P3' || this.telemSelected.value == 'PT' || this.compare(this.telemSelected.value, ['P1', 'P2']) || this.compare(this.telemSelected.value, ['P1', 'P3']) || this.compare(this.telemSelected.value, ['P1', 'PT']) || this.compare(this.telemSelected.value, ['P2', 'P3']) || this.compare(this.telemSelected.value, ['P2', 'PT']) || this.compare(this.telemSelected.value, ['P3', 'PT']) || this.compare(this.telemSelected.value, ['P2', 'P3', 'PT']) || this.compare(this.telemSelected.value, ['P1', 'P2', 'P3']) || this.compare(this.telemSelected.value, ['P1', 'P2', 'P3', 'PT']))
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'kW';
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Potencia
              else if (this.telemSelected.value == 'S1' || this.telemSelected.value == 'S2' || this.telemSelected.value == 'S3' || this.telemSelected.value == 'ST' || this.compare(this.telemSelected.value, ['S1', 'S2']) || this.compare(this.telemSelected.value, ['S1', 'S3']) || this.compare(this.telemSelected.value, ['S1', 'ST']) || this.compare(this.telemSelected.value, ['S2', 'S3']) || this.compare(this.telemSelected.value, ['S2', 'ST']) || this.compare(this.telemSelected.value, ['S3', 'ST']) || this.compare(this.telemSelected.value, ['S2', 'S3', 'ST']) || this.compare(this.telemSelected.value, ['S1', 'S2', 'S3']) || this.compare(this.telemSelected.value, ['S1', 'S2', 'S3', 'ST']))
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'kVA';
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Volts
              else if (this.telemSelected.value == 'V1' || this.telemSelected.value == 'V2' || this.telemSelected.value == 'V3' || this.compare(this.telemSelected.value, ['V1', 'V2']) || this.compare(this.telemSelected.value, ['V1', 'V3']) || this.compare(this.telemSelected.value, ['V2', 'V3']) || this.compare(this.telemSelected.value, ['V1', 'V2', 'V3']))
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'Volts';
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Volts
              else if (this.telemSelected.value == 'V1_V2' || this.telemSelected.value == 'V2_V3' || this.telemSelected.value == 'V3_V1' || this.compare(this.telemSelected.value, ['V1_V2', 'V2_V3']) || this.compare(this.telemSelected.value, ['V1_V2', 'V3_V1']) || this.compare(this.telemSelected.value, ['V2_V3', 'V3_V1']) || this.compare(this.telemSelected.value, ['V1_V2', 'V2_V3', 'V3_V1']))
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'Volts';
              }
              //Volts para UPS
              else if (this.telemSelected.value == 'V1i' || this.telemSelected.value == 'V1o' || this.telemSelected.value == 'V2i' || this.telemSelected.value == 'V2o' || this.telemSelected.value == 'V3i' || this.telemSelected.value == 'V3o' || this.compare(this.telemSelected.value, ['V1i', 'V1o']) || this.compare(this.telemSelected.value, ['V2i', 'V2o']) || this.compare(this.telemSelected.value, ['V3i', 'V3o']) || this.compare(this.telemSelected.value, ['V1i', 'V2i']) || this.compare(this.telemSelected.value, ['V1i', 'V3i']) || this.compare(this.telemSelected.value, ['V2i', 'V3i']) || this.compare(this.telemSelected.value, ['V1o', 'V2o']) || this.compare(this.telemSelected.value, ['V1o', 'V3i']) || this.compare(this.telemSelected.value, ['V1i', 'V2i', 'V3i']) || this.compare(this.telemSelected.value, ['V1o', 'V2o', 'V3o']) || this.compare(this.telemSelected.value, ['V1i', 'V2i', 'V3i']) )
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'Volts';
              }
              //Corrientes para UPS
              else if (this.telemSelected.value == 'I1i' || this.telemSelected.value == 'I1o' || this.telemSelected.value == 'I2i' || this.telemSelected.value == 'I2o' || this.telemSelected.value == 'I3i' || this.telemSelected.value == 'I3o' || this.compare(this.telemSelected.value, ['I1i', 'I2i']) || this.compare(this.telemSelected.value, ['I1o', 'I2o']) || this.compare(this.telemSelected.value, ['I1o', 'I2i']) || this.compare(this.telemSelected.value, ['I1i', 'I2o']) || this.compare(this.telemSelected.value, ['I1i', 'I3i']) || this.compare(this.telemSelected.value, ['I1o', 'I3o']) || this.compare(this.telemSelected.value, ['I1o', 'I3i']) || this.compare(this.telemSelected.value, ['I1i', 'I3o']) || this.compare(this.telemSelected.value, ['I2i', 'I3i']) || this.compare(this.telemSelected.value, ['I2o', 'I3o']) || this.compare(this.telemSelected.value, ['I2o', 'I3i']) || this.compare(this.telemSelected.value, ['I2i', 'I3o']) || this.compare(this.telemSelected.value, ['I1i', 'I2i', 'I3i']) || this.compare(this.telemSelected.value, ['I1o', 'I2o', 'I3o']) || this.compare(this.telemSelected.value, ['I1i', 'I2o', 'I3o']) || this.compare(this.telemSelected.value, ['I1o', 'I2i', 'I3o']) || this.compare(this.telemSelected.value, ['I1i', 'I2i', 'I3i'])) 
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = 'Amps';
              }
              //Sino es ninguna unidad es null
              else
              {
                this.superChart.options.vAxis.viewWindow.min = 0;
                this.superChart.options.vAxis.title = null;
                this.superChart.options.trendlines = null;
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 1}
                                                 };
              }
              //Con esto se sabe de cuantos datos esta compuesto el resultado de BD
              if (result[0] != undefined)
                {var tsIndex = result[0].length;}
              else
                {tolerance = 0;}

              console.log('Epsilon: ',tolerance);
              if (tolerance != 0){
                if (tsIndex - 1 == 1) //si solo hay un valor seleccionado
                {  
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  if (typeof result[0][0] === 'string') //si es la energia se hace el parse a float
                  {
                    datas[0] =  [parseFloat(result[0][0]), 0]
                    for(i= 1 ; i<arrData; i++)     //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                    {
                      var det = [ result[i][0], i ];
                      datas.push(det[0]);
                      
                      datas[i] = [ parseFloat(result[i][0]), i ];
                    }
                  }
                  else //sino se sige normal
                  {
                    datas[0] =  [result[0][0], 0]
                    for(i= 1 ; i<arrData; i++)     //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                    {
                      var det = [ result[i][0], i ];
                      datas.push(det[0]);
                      
                      datas[i] = [ result[i][0], i ];
                    }
                  }
                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  var simplifiedResult = SimplifyAP(points, tolerance, higQuality);
                  
                  if (simplifiedResult.length < 100)
                    {
                      simplifiedResult = SimplifyAP(points, 0.1, higQuality);
                      console.log('re-simplificado por pocos puntos')
                    }

                  if (this.telemSelected.value[0] != 'E' && this.telemSelected.value[0] != 'freq' && this.telemSelected.value[0] != 'FP' && this.telemSelected.value[0] != 'Temp')
                  {
                    headerParams[2] = this.telemSelected.value[0]+"(Prom.)";
                    //aqui le doy otro grosor
                    this.superChart.options.series = {0: {lineWidth: 1},
                                                      1: {lineWidth: 2,
                                                          lineDashStyle: [2,2,2]}}
                    this.superChart.options.trendlines = {
                      0: {
                        color: 'yellow',
                        lineWidth: 2,
                        type: 'lineal',
                        degree: 4,
                        opacity: 0.6,
                        tooltip: false,
                        visibleInLegend: true,
                        labelInLegend: 'Tendencia'
                      }
                    };
                    
                    var timeseries = require("timeseries-analysis");
                    
                    var SMA = [];
                    for(i = 0; i<simplifiedResult.length ; i++)
                    {
                      SMA.push([1]);
                      SMA[i] = [  result[simplifiedResult[i][1]][tsIndex -1] , simplifiedResult[i][0]];
                    }
                    console.log(SMA);
                    var t = new timeseries.main(SMA);
                    var final = t.ma( { period: 1 } ).smoother({ period: 300}).output();
                    console.log(final);

                    /*
                    var originalSize = Object.keys(result).length;
                    var SMA = [];
                    for(i=0; i<originalSize; i++)
                    {
                      SMA.push([1]);
                      SMA[i] = result[i][0];
                    }
                    SMA = ma(SMA, this.SMAEpsilon);

                    var SMA2 = [];
                    for(i = 0; i<simplifiedResult.length ; i++)
                    {
                      SMA2.push([1]);
                      SMA2[i] = SMA[simplifiedResult[i][1]];
                    }

                    SMA2 = ma(SMA2, this.SMAEpsilon);
                    console.log(SMA2);
                    */

                    var processedResult = [];
                    for(i = 0; i<simplifiedResult.length ; i++)
                    {
                      processedResult.push([1]);
                      //processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      processedResult[i] = [ simplifiedResult[i][0], final[i][1], result[simplifiedResult[i][1]][tsIndex -1] ];
                    }
                    var devs = new timeseries.main(processedResult);
                    console.log('Desviacion: ' + devs.stdev());
                  }
                  else
                  {
                    if(this.telemSelected.value[0] == 'Temp')
                    {
                      var timeseries = require("timeseries-analysis");
                      headerParams[2] = 'Min.';
                      headerParams[3] = 'Max.';
                      var stream = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        stream[i] = 1;
                        stream[i] = [i, simplifiedResult[i][0]]
                      }
                      var s = new timeseries.main(stream);
                      var min = s.min().toFixed(1);
                      var max = s.max().toFixed(1);
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0].toFixed(1), min, max, result[simplifiedResult[i][1]][tsIndex -1] ];
                      }
                    }
                    else
                    {
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ];
                      }
                    }
                  }

                }
                else if (tsIndex - 1 == 2) //Si hay seleccionados dos parametros hace matriz del segundo valor
                {
                  //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  datas[0] =  [result[0][0], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][0], i ];
                    datas.push(det[0]);
                    datas[i] = [ result[i][0], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 2)
                  let datas2: ISimplifyArrayPoint[] =[[0,1]];
                  datas2[0] =  [result[0][1], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][1], i ];
                    datas2.push(det[0]);
                    datas2[i] = [ result[i][1], i ];
                  }

                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  var simpResult1 = SimplifyAP(points, tolerance, higQuality);

                  var points2: ISimplifyArrayPoint[] = datas2;
                  var higQuality: boolean = false;
                  var simpResult2 = SimplifyAP(points2, tolerance, higQuality);

                  if (simpResult1.length > simpResult2.length) //se ve cual grafico tuvo mas variacion y se utiliza como indice.
                    {
                      var simplifiedResult = simpResult1;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else
                    {
                      var simplifiedResult = simpResult2;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                }
                else if (tsIndex - 1 == 3) //Si hay seleccionados tres parametros hace matriz del tercer valor
                {
                  //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  datas[0] =  [result[0][0], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][0], i ];
                    datas.push(det[0]);
                    datas[i] = [ result[i][0], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 2)
                  let datas2: ISimplifyArrayPoint[] =[[0,1]];
                  datas2[0] =  [result[0][1], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][1], i ];
                    datas2.push(det[0]);
                    datas2[i] = [ result[i][1], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 3)
                  let datas3: ISimplifyArrayPoint[] =[[0,1]];
                  datas3[0] =  [result[0][2], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][2], i ];
                    datas3.push(det[0]);
                    datas3[i] = [ result[i][2], i ];
                  }

                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  var simpResult1 = SimplifyAP(points, tolerance, higQuality);

                  var points2: ISimplifyArrayPoint[] = datas2;
                  var higQuality: boolean = false;
                  var simpResult2 = SimplifyAP(points2, tolerance, higQuality);

                  var points3: ISimplifyArrayPoint[] = datas3;
                  var higQuality: boolean = false;
                  var simpResult3 = SimplifyAP(points3, tolerance, higQuality);

                  if (simpResult1.length > simpResult2.length && simpResult3.length) //se ve cual grafico tuvo mas variacion y se utiliza como indice.
                    {
                      console.log('varia 1')
                      var simplifiedResult = simpResult1;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult2.length > simpResult1.length && simpResult3.length)
                    {
                      console.log('varia 2')
                      var simplifiedResult = simpResult2;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], simplifiedResult[i][0], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult3.length > simpResult1.length && simpResult2.length)
                    {
                      console.log('varia 3')
                      var simplifiedResult = simpResult3;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], result[simplifiedResult[i][1]][1], simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else
                  {
                    console.log('entra en caso extremo');
                    simpResult1 = SimplifyAP(points, 0, higQuality);

                    var simplifiedResult = simpResult1;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                  }

                }
                else if (tsIndex - 1 == 4) //Si hay seleccionados cuatro parametros hace matriz del cuarto valor
                {
                  //Aqui se rellena una matriz con los datos de la matriz original (valor 1)
                  let datas: ISimplifyArrayPoint[] =[[0,1]];
                  datas[0] =  [result[0][0], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][0], i ];
                    datas.push(det[0]);
                    datas[i] = [ result[i][0], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 2)
                  let datas2: ISimplifyArrayPoint[] =[[0,1]];
                  datas2[0] =  [result[0][1], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][1], i ];
                    datas2.push(det[0]);
                    datas2[i] = [ result[i][1], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 3)
                  let datas3: ISimplifyArrayPoint[] =[[0,1]];
                  datas3[0] =  [result[0][2], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][2], i ];
                    datas3.push(det[0]);
                    datas3[i] = [ result[i][2], i ];
                  }

                  //Aqui se rellena una matriz con los datos de la matriz original (valor 4)
                  let datas4: ISimplifyArrayPoint[] =[[0,1]];
                  datas4[0] =  [result[0][3], 0]
                  for(i= 1 ; i<arrData; i++)     
                  {
                    var det = [ result[i][3], i ];
                    datas4.push(det[0]);
                    datas4[i] = [ result[i][3], i ];
                  }

                  var points: ISimplifyArrayPoint[] = datas;
                  var higQuality: boolean = false;
                  var simpResult1 = SimplifyAP(points, tolerance, higQuality);

                  var points2: ISimplifyArrayPoint[] = datas2;
                  var higQuality: boolean = false;
                  var simpResult2 = SimplifyAP(points2, tolerance, higQuality);

                  var points3: ISimplifyArrayPoint[] = datas3;
                  var higQuality: boolean = false;
                  var simpResult3 = SimplifyAP(points3, tolerance, higQuality);

                  var points4: ISimplifyArrayPoint[] = datas4;
                  var higQuality: boolean = false;
                  var simpResult4 = SimplifyAP(points4, tolerance, higQuality);

                  if (simpResult1.length > simpResult2.length && simpResult3.length && simpResult4.length) //se ve cual grafico tuvo mas variacion y se utiliza como indice.
                    {
                      var simplifiedResult = simpResult1;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][3], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult2.length > simpResult1.length && simpResult3.length && simpResult4.length)
                    {
                      var simplifiedResult = simpResult2;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], simplifiedResult[i][0], result[simplifiedResult[i][1]][2], result[simplifiedResult[i][1]][3], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult3.length > simpResult1.length && simpResult2.length && simpResult4.length)
                    {
                      var simplifiedResult = simpResult3;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], result[simplifiedResult[i][1]][1], simplifiedResult[i][0], result[simplifiedResult[i][1]][3], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }
                  else if(simpResult4.length > simpResult1.length && simpResult2.length && simpResult3.length)
                    {
                      var simplifiedResult = simpResult3;
                      var processedResult = [];
                      for(i = 0; i<simplifiedResult.length ; i++)
                      {
                        processedResult.push([1]);
                        processedResult[i] = [ result[simplifiedResult[i][1]][0], result[simplifiedResult[i][1]][1], result[simplifiedResult[i][1]][2], simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                      }
                    }

                }
                          

                result = processedResult;
                arrData = Object.keys(result).length;
                console.log('Simplificado: ', arrData);
              }
              else if (tsIndex - 1 == 1 && this.telemSelected.value[0] != 'E') //Si solo hay un valor y epsilon 0 se agrega la linea de promedio
              {
                if(tsIndex - 1 == 1 && this.telemSelected.value[0] != 'freq' && this.telemSelected.value[0] != 'Temp')
                {
                  headerParams[2] = this.telemSelected.value[0]+"(Prom.)";
                  this.superChart.options.series = {0: {lineWidth: 1},
                                                      1: {lineWidth: 2}}
                  this.superChart.options.trendlines = {
                    0: {
                      color: 'yellow',
                      lineWidth: 2,
                      type: 'lineal',
                      degree: 4,
                      opacity: 0.6,
                      tooltip: false,
                      visibleInLegend: true,
                      labelInLegend: 'Tendencia'
                    }
                  };
                  headerParams[2] = this.telemSelected.value[0]+"(Prom.)";
                  this.superChart.options.series = {0: {lineWidth: 1},
                                                      1: {lineWidth: 2}}
                  var SMA = [];
                  for(i=0; i<Object.keys(result).length; i++)
                  {
                    SMA.push([1]);
                    SMA[i] = result[i][0];
                  }
                  SMA = ma(SMA, this.SMAEpsilon);

                  var processedResult = [];
                  for(i = 0; i<SMA.length ; i++)
                  {
                    processedResult.push([1]);
                    //processedResult[i] = [ simplifiedResult[i][0], result[simplifiedResult[i][1]][tsIndex -1] ]
                    processedResult[i] = [ result[i][0], SMA[i], result[i][tsIndex -1] ]
                  }
                  result = processedResult;
                  arrData = Object.keys(result).length;
                }
              }    
              
              if(this.telemSelected.value[0] == 'Temp')
              {
                this.superChart.options.vAxis.title = '°C';
                this.superChart.options.trendlines = {
                  0: {
                    color: 'yellow',
                    lineWidth: 1,
                    type: 'lineal',
                    degree: 4,
                    opacity: 0.6,
                    tooltip: false,
                    visibleInLegend: true,
                    labelInLegend: 'Tendencia'
                  }
                };
                this.superChart.options.series = {0: {lineWidth: 1},
                                                  1: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'yellow'},
                                                  2: {lineWidth: 2, lineDashStyle: [2,2,2], color: 'green'}
                                                 }

              }

              this.superChart.dataTable[0] = headerParams;

              var lastdatasize = this.superChart.dataTable.length;

              if (typeof result[0] !== "undefined")
                {
                var arrSize = result[0].length - 1;}

              //aqui se agranda la matriz para que concuerde con los datos que llegan de BD
              if (arrData > (lastdatasize - 1)){
                var toadd = arrData - ( lastdatasize - 1)
                for(i = 0; i<toadd; i++){
                  this.superChart.dataTable[i + lastdatasize] = this.superChart.dataTable[1];
                }
              }
              else if (arrData < (lastdatasize - 1)){ //Aqui se acorta la matriz por si vienen pocos valores de BD
                this.superChart.dataTable = []
                this.superChart.dataTable[0] = headerParams;
                var toadd = arrData;
                for(i = 0; i<toadd; i++){
                  this.superChart.dataTable[i + 1] = ['10:20', 1];
                }       
              }

              if(typeof result[0] !== "undefined")
              {
                //var data = new google.visualization.DataTable();
                //data.addColumn('datetime', 'Time');
                //for (i= 1; i< headerParams.length; i++)
                //{
                //  data.addColumn('number', headerParams[i]);
                //}
                for(i= arrData - 1; i>-1; i--)
                {
                  if (typeof result[i] !== "undefined")
                  {
                    let dummy = result[i][arrSize].split(' ');
                    let dummy2 = dummy[0].split('-');
                    let date = dummy2[1]+'/'+dummy2[2]+'/'+dummy2[0];
                    let fullfixed = date+' '+dummy[1];
                    var d = new Date(fullfixed);
                    /*
                    ts = result[i][arrSize].split(" ");
                    ts = ts[1];
                    ts = ts.split(":");
                    var hour = ts[0];
                    var mins = ts[1];
                    var year = new Date().getFullYear();
                    var month = new Date().getMonth();
                    var day = new Date().getDate();
                    */
                    ts = d; //sets the date from payload
                    //updates the current chart for 4 values
                    if (result[i].length == 5)
                    {
                      this.update_chart(this.superChart, [result[i][0], result[i][1], result[i][2], result[i][3]], ts);
                    }
                    //updates the current chart for 3 values
                    if (result[i].length == 4)
                    {
                      this.update_chart(this.superChart, [result[i][0], result[i][1], result[i][2]], ts);
                    }
                    //updates the current chart for 2 values
                    if (result[i].length == 3)
                    {
                      //data.addRow([ts, result[i][0], result[i][1]])
                      this.update_chart(this.superChart, [result[i][0], result[i][1]], ts);
                    }
                    //updates the current chart for 1 values
                    if (result[i].length == 2)
                    {
                      //data.addRow([ts, result[i][0]])
                      this.update_chart(this.superChart, [result[i][0]], ts);
                    }
                  };
                };
              }
              else
              {
                this.update_chart(this.superChart, [0, 0, 0]);
                
                this.superChart.dataTable =this.emptyTable;
                this.snackBar.open('No hay datos!.', 'x', {duration: 3500, verticalPosition: 'top'});
              }
              if(typeof result[0] !== "undefined")
              {
                //updates the current chart for 4 values
                if (result[0].length == 5)
                {
                  this.update_chart(this.superChart, [null, null, null, null], endDate);
                }
                //updates the current chart for 3 values
                if (result[0].length == 4)
                {
                  this.update_chart(this.superChart, [null, null, null], endDate);
                }
                //updates the current chart for 2 values
                if (result[0].length == 3)
                {
                  this.update_chart(this.superChart, [null, null], endDate);
                }
                //updates the current chart for 1 values
                if (result[0].length == 2)
                {
                  //data.addRow([ts, result[i][0]])
                  this.update_chart(this.superChart, [null], endDate);
                }
              }
              //var view = new google.visualization.DataView(data);
              //this.superChart.dataTable = view;
              this.redrawfunction(this.superChart); 
              this.showProgress = false; 
              this.sub.unsubscribe();
            })
          }
      }
      }
  }

  updateSelectedCount(count: number) {
    this.selectedCount = count;
  }

  updateSelectedCount2(count: number) {
    this.selectedCount2 = count;
  }

  downloadFile(data: any, device, zone, city, office, start, end) {
    const replacer = (key, value) => value === null ? '-' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    csv[0] = this.telemSelected.value
    csv[0].push('Fecha Hora');
    csv[0].push('Dispositivo: ' + device);
    csv[0].push('Lugar: ' + zone + '/' + city + '/' + office);
    let csvArray = csv.join('\r\n');
    
    
    var a = document.createElement('a');
    var blob = new Blob([csvArray], {type: 'text/csv' }),
    url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = "Consutlta-desde_"+start+"-hasta_"+end+".csv";
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    
}

  //funcion de delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=> null);
  }

  select(event: ChartSelectEvent, chart){
    //Aqui va codigo si es posible ocultar por completo una serie
    if(event.row == null)
    {
      //["#FE1B07", "#FFF", "#27C5F8", "#FFFF00"]
      let colors = this.superChart.options.colors
      if(event.column == 1)
      {
        if(colors[0] == 'transparent')
        {colors[0] = '#FE1B07'}
        else
        {colors[0] = 'transparent'}
      } 
      else if(event.column == 2)
      {
        if(colors[1] == 'transparent')
        {colors[1] = '#FFF'}
        else
        {colors[1] = 'transparent'}
      }
      else if(event.column == 3)
      {
        if(colors[2] == 'transparent')
        {colors[2] = '#27C5F8'}
        else
        {colors[2] = 'transparent'}
      }
      else if(event.column == 4)
      {
        if(colors[3] == 'transparent')
        {colors[3] = '#FFFF00'}
        else
        {colors[3] = 'transparent'}
      }

      this.superChart.options.colors = colors;
      this.redrawfunction(this.superChart);
    }
  }

  compare(array1, array2) {
    if (array1.length != array2.length) {
      return false;
    }
  
    array1 = array1.slice();
    array1.sort();
    array2 = array2.slice();
    array2.sort();
  
    for (var i = 0; i < array1.length; i++) {
      if (array1[i] != array2[i]) {
        return false;
      }
    }
  
    return true;
  }

}
